export default __webpack_public_path__ + "static/Крысиные бега_19-e7b3cfe5bbc88d272a5c4fc6faedb170.jpg";